<template>
    <ul :class='"list list-" + $parent.model'>

        <router-link tag='li' :to='$parent.getOpenLink(null, item.id)' v-for="item in $parent.items.data" :key='item.id' :class='"list-" + $parent.model + "_item"'>
            <h2 class="h6"><strong>{{item.title}}</strong></h2>
            <p v-text='"Scope: " + getScope(item)'></p>
            <p v-if='is_network_admin() && item.user'>{{ capitalise($t('translations.owner')) }}: {{formatName(item.user)}}</p>
			<p>{{item.content | excerpt}}</p>
        </router-link>
    </ul>
</template>

<script>
    export default {
        props: [
        ],
        data: function() {
            return {
			};
        },
        methods: {
			getScope(item) {
                if(item.user_id) {
                    return this.$t('translations.personal');
                }
                else {
                    if(item.provider_id) {
                        if(this.is_network_admin()) {
                            return this.$t('translations.organisational') + ": " + item.provider.name;
                        }
                        return this.$t('translations.organisational');

                    }
                    return this.$t('translations.global');
                }
            }
        }
    }
</script>
